export default __webpack_public_path__ + "static/media/gold-cube.68d0ebe3.png";